import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../../services/user.service';
import { ToastService } from '../../../_core/services/toast.service';
import { ResetPasswordDialogComponent } from 'src/app/_shared/components/dialogs/reset-password-dialog/reset-password-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LoginDialogComponent } from 'src/app/login/components/login-dialog/login-dialog.component';
import { Util } from 'src/app/util';
import { ActionType } from 'src/app/models/action';

@Component({
  selector: 'app-user-create-guest-account',
  templateUrl: './user-create-guest-account.component.html',
  styleUrls: ['./user-create-guest-account.component.scss'],
})
export class UserCreateGuestAccountComponent implements OnInit {
  private readonly toastService = inject(ToastService);
  private readonly matDialog = inject(MatDialog);
  private readonly userService = inject(UserService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  @ViewChild('resetPasswordDialog', { static: true }) resetPasswordDialog!: ResetPasswordDialogComponent;

  ngOnInit() {
    const token = this.route.snapshot.params['token'];

    this.userService.createGuestAccount(token).subscribe({
      next: (user) => {
        this.toastService.showToast('user.invitations.accountCreated');
        this.resetPasswordDialog.openModal(user.session);
      },
      error: (err: HttpErrorResponse) => {
        switch (err.status) {
          case 400:
          case 404:
            this.toastService.showToast('user.invitations.error.creatingAccount', 'error');
            break;
          case 403:
            this.toastService.showToast('user.invitations.error.policyNotExist', 'error');
            break;
          case 409:
            this.toastService.showToast('user.invitations.error.alreadyUsed', 'error');
            break;
          default:
            throw err;
        }

        this.router.navigate(['/']);
      }
    });
  }

  handleResetPasswordDialog() {
    this.router.navigate(['/']);
    this.matDialog
      .open(LoginDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (!result) {
          const action = Util.getAction();
          if (action) {
            Util.setAction({
              ...action,
              type: ActionType.NONE,
            });
          } else {
            Util.removeAction();
          }
        } else {
          (window as any).location.reload();
        }
      });
  }
}
